import emitter from './emitter';
var handledKeyCodes = {
  downArrow: 40,
  enter: 13,
  escape: 27,
  upArrow: 38
};
export var internal = {
  genericKeyDownHandler: function genericKeyDownHandler(emitterImpl) {
    return function (keyCode, eventName, menuOpen, ev) {
      if (ev.which !== keyCode) {
        return;
      } // if predictions are showing, prevent default so the cursor
      // doesn't move/"form submit"-type actions aren't taken, etc.


      if (menuOpen) {
        ev.preventDefault();
        emitterImpl.emit(eventName);
      }
    };
  },
  otherKeyDownHandler: function otherKeyDownHandler(emitterImpl) {
    return function (ev) {
      var codes = Object.keys(handledKeyCodes).map(function (key) {
        return handledKeyCodes[key];
      }); // bail if this is an otherwise handled key

      if (codes.find(function (code) {
        return code === ev.which;
      })) {
        return;
      }

      emitterImpl.emit('otherKey');
    };
  },
  getHelpers: function getHelpers(genericKeyDownHandler, otherKeyDownHandler) {
    return {
      handleDownArrow: function handleDownArrow(menuOpen, ev) {
        return genericKeyDownHandler(handledKeyCodes.downArrow, 'downArrow', menuOpen, ev);
      },
      handleUpArrow: function handleUpArrow(menuOpen, ev) {
        return genericKeyDownHandler(handledKeyCodes.upArrow, 'upArrow', menuOpen, ev);
      },
      handleEnter: function handleEnter(menuOpen, ev) {
        return genericKeyDownHandler(handledKeyCodes.enter, 'enterKey', menuOpen, ev);
      },
      handleEscape: function handleEscape(menuOpen, ev) {
        return genericKeyDownHandler(handledKeyCodes.escape, 'escapeKey', menuOpen, ev);
      },
      handleOther: function handleOther(ev) {
        return otherKeyDownHandler(ev);
      }
    };
  },
  onKeyDown: function onKeyDown(helpers) {
    return function (menuOpen, ev) {
      helpers.handleDownArrow(menuOpen, ev);
      helpers.handleUpArrow(menuOpen, ev);
      helpers.handleEnter(menuOpen, ev);
      helpers.handleEscape(menuOpen, ev);
      helpers.handleOther(ev);
    };
  }
};
var genericKeyDownHandler = internal.genericKeyDownHandler(emitter);
var otherKeyDownHandler = internal.otherKeyDownHandler(emitter);
var helpers = internal.getHelpers(genericKeyDownHandler, otherKeyDownHandler);
export var onKeyDown = internal.onKeyDown(helpers);
//# sourceMappingURL=events.js.map